import { useState } from "react"
import { CellContext } from "@tanstack/react-table"
import styled from "styled-components"

import { useLazyGetMessageTemplateQuery } from "store/api/contractorsApi"
import { UITypes } from "types"

import MessageDrawer from "./MessageDrawer"

const SeeMessageButton = styled.span`
  &:hover {
    color: #2db2c8;
    text-decoration: underline;
    cursor: pointer;
  }
`

interface Props {
  cell: CellContext<UITypes.TableBodyRow, UITypes.TableBodyCell>
}

const MessageCenterSeeMessage = ({ cell: { getValue } }: Props) => {
  const templateId = getValue().value ? Number(getValue().value) : null
  const [triggerGetMessageTemplate, { data: messageTemplate, isFetching }] = useLazyGetMessageTemplateQuery()
  const [showSeeMessageModal, setShowSeeMessageModal] = useState(false)

  const handleSeeMessage = () => {
    if (!templateId) return

    triggerGetMessageTemplate(templateId)
    setShowSeeMessageModal(true)
  }

  const handleCancelClick = () => {
    setShowSeeMessageModal(false)
  }

  if (!templateId) return null

  return (
    <>
      <SeeMessageButton onClick={handleSeeMessage}>See message</SeeMessageButton>
      {showSeeMessageModal && (
        <MessageDrawer
          isFetching={isFetching}
          handleCancelClick={handleCancelClick}
          messageTemplate={messageTemplate?.data}
        />
      )}
    </>
  )
}

export default MessageCenterSeeMessage
